import React from 'react';

interface NotificationBannerProps {
  message: string;
  isVisible: boolean;
}

export function NotificationBanner({ message, isVisible }: NotificationBannerProps) {
  if (!message) return null;

  return (
    <div 
      className="fixed top-24 left-0 right-0 z-50" /* Changed from top-16 to top-24 to match new header height */
      style={{
        opacity: isVisible ? 1 : 0,
        transform: `translateY(${isVisible ? '0' : '-100%'})`,
        transition: 'transform 300ms ease-in-out, opacity 300ms ease-in-out',
        pointerEvents: isVisible ? 'auto' : 'none',
      }}
    >
      <div className="bg-[#5e9bb8] text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 text-center">
          {message}
        </div>
      </div>
    </div>
  );
}